import { Facebook, Instagram } from 'blaze-ui/icons'
import { Button } from 'blaze-ui/Button'
import Styles from './BrandWizardIntegrationSelection.module.scss'
import { useInitiateOauth } from 'hooks/useInitiateOauth'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

const ConnectFacebook = ({ onPress }: { onPress: () => void }) => {
  return (
    <Button size="lg" variant="secondary" frontIcon={Facebook} onPress={onPress}>
      Connect Facebook
    </Button>
  )
}

const ConnectInstagram = ({ onPress }: { onPress: () => void }) => {
  return (
    <Button size="lg" variant="secondary" frontIcon={Instagram} onPress={onPress}>
      Connect Instagram
    </Button>
  )
}

export const ConnectButtons = () => {
  const { initiateOauth } = useInitiateOauth()
  return (
    <div className={Styles.connectButtons}>
      <ConnectFacebook onPress={() => initiateOauth(ExternalIntegrationEnum.Facebook)} />
      <ConnectInstagram onPress={() => initiateOauth(ExternalIntegrationEnum.Instagram)} />
    </div>
  )
}
